import {generateSlider} from '../exports/generateSwiper';
import {cabinetsSwiperSettings} from '../exports/swiperSettings';
export default {
  init() {
    /*
    * SELECTORS
    */
    let flippersBoxes = document.querySelectorAll('.single-cabinet')
    let flippers = document.querySelectorAll('.single-cabinet .front')
    let flippersClose = document.querySelectorAll('.single-cabinet .go-back')
    let cabinetsSwiper = '.cabinetsSwiper'
    /*
    * EVENTS
    */
    /*
     * ACTIONS
     */
    flippers.forEach(el => {
      el.addEventListener('click', (box) => {
        flippersBoxes.forEach(el => el.classList.remove('flip'))
        box.target.closest('.single-cabinet').classList.add('flip')
      })
    })

    flippersClose.forEach(el => {
      el.addEventListener('click', (box) => {
        box.target.closest('.single-cabinet').classList.remove('flip')
      })
    })
    generateSlider(cabinetsSwiper, cabinetsSwiperSettings)
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/vlt.js